import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class ChancenDynamicClassFormOfFinanzingFilter extends AdornisFilter {
  static override _class = 'ChancenDynamicClassFormOfFinanzingFilter';

  override searchFields: string[] | undefined = ['class', 'name'];
}
